<template>
  <div class="c-base-modal">
    <div class="c-base-modal__wrapper">
      <button
        v-if="!required"
        @click="closeModal"
        type="button"
        class="c-base-modal__close"
      >
        <base-icon width="26" height="26" name="painel/close-icon" />
      </button>
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      globalTagHTML: null,
    }
  },
  methods: {
    closeModal() {
      if (this.close) {
        this.close()
      } else {
        this.$emit('modalState', false)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.c-base-modal {
  @include position(fixed, 0, 0, 0, 0);
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 203;
  background-color: $overlay;

  &__wrapper {
    @include position(absolute, calc(50% + 30px), 0, auto, 0, -50%);
    max-width: calc(100% - 32px);
    width: 100%;
    max-height: 80vh;
    margin: 0 auto;
    overflow-y: auto;
    background-color: $white;
    @media (min-width: $tablet) {
      max-width: 420px;
    }
  }

  &__close {
    @include position(absolute, 1em, 1em, auto, auto);
    border: 0;
    z-index: 10;
    cursor: pointer;
    color: $gray-5;
    background-color: transparent;
    padding: 0;
    outline: none;
    &:hover {
      color: $gray-7;
    }
  }
}
</style>
